var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirtIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7 10.3L26 6.6C24.3 4.9 22 4 19.6 4H19.4C19 4 18.7 4.2 18.5 4.5C18 5.4 17.1 6 16 6C14.9 6 14 5.4 13.4 4.5C13.2 4.2 12.9 4 12.6 4H12.4C9.90001 4 7.60001 4.9 5.90001 6.6L2.20001 10.3C1.80001 10.7 1.80001 11.2 2.10001 11.6L6.10001 16.6C6.40001 16.8 6.70001 17 6.90001 17C7.20001 17 7.50001 16.9 7.70001 16.7L9.00001 15.4V27C9.00001 27.6 9.40001 28 10 28H22C22.6 28 23 27.6 23 27V15.4L24.3 16.7C24.5 16.9 24.8 17 25.1 17C25.4 17 25.6 16.8 25.8 16.6L29.8 11.6C30.1 11.2 30.1 10.7 29.7 10.3Z",
    fill: "#FDA94A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirtIconOrange);
export default __webpack_public_path__ + "static/media/tshirt-icon-orange.f64c54b39162e41f97edf78768d4a972.svg";
export { ForwardRef as ReactComponent };